import { createUseStyles } from 'react-jss'

import { sizes, colors } from '../variables.style'
import { emptyStateCards } from './report-empty-state.style'

export const style = {
  ...emptyStateCards,
  reportIdInput: {
    border: '2px dashed black',
    borderRadius: '18px',
    height: sizes.buttonHeight,
    width: '200px',
    textAlign: 'center',
    fontSize: 12,
    padding: '0 10px',

    '&:focus': {
      borderColor: colors.oriolesOrange
    }
  },
  copyAndRefreshButton: {
    marginLeft: '8px'
  }
}

export const useStyles = createUseStyles(style)
